import { ThemeEvents, CartUpdatedEvent } from '@theme/events';

/**
 * Validateur de panier pour sécuriser l'offre à deux produits.
 * Explications du POURQUOI de la logique :
 * - Le filtre à 0€ ne doit jamais être acheté seul. Si le client supprime les cartouches de son panier,
 *   ce script détecte l'absence de cartouches et supprime automatiquement le filtre gratuit.
 * - Nous évitons ainsi toute triche dans le panier tout en conservant une intégration simple
 *   sans avoir besoin de règles de swap complexes dans Kaching Subscriptions.
 */
function enforceCartRules() {
  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      // Recherche du filtre gratuit (prix à 0 et handle contenant 'filtre')
      const freeFilterItem = cart.items.find(
        (item) => item.price === 0 && item.handle.includes('filtre')
      );
      
      // Vérification de la présence de cartouches
      const hasCartridges = cart.items.some((item) => item.handle.includes('cartouche'));

      // Si le filtre gratuit est présent mais pas les cartouches, on le supprime
      if (freeFilterItem && !hasCartridges) {
        console.log('CartValidator: Cartouches absentes. Suppression du filtre gratuit.');
        
        const updates = {};
        updates[freeFilterItem.key] = 0;

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        })
          .then((res) => res.json())
          .then((updatedCart) => {
            if (window.location.pathname === '/cart' || window.location.pathname.includes('/cart')) {
              // Si on est sur la page panier, on recharge simplement pour actualiser
              window.location.reload();
            } else {
              // Si on est sur une autre page (avec le tiroir panier), on demande le re-rendu de la section cart-drawer
              const drawer = document.querySelector('cart-drawer');
              const sections = [];
              if (drawer) {
                sections.push(drawer.dataset.sectionId);
              }

              fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  updates: {},
                  sections: sections.join(','),
                }),
              })
                .then((res) => res.json())
                .then((responseWithSections) => {
                  // Notification de la mise à jour du panier pour rafraîchir l'interface
                  document.dispatchEvent(
                    new CartUpdatedEvent(
                      {},
                      {
                        itemCount: responseWithSections.item_count,
                        source: 'cart-validator',
                        sections: responseWithSections.sections,
                      }
                    )
                  );
                });
            }
          })
          .catch((err) => console.error('CartValidator: Erreur lors de la mise à jour du panier:', err));
      }
    })
    .catch((err) => console.error('CartValidator: Erreur lors de la lecture du panier:', err));
}

// Écouter les mises à jour du panier pour déclencher la validation (sauf si elles proviennent du validateur lui-même)
document.addEventListener(ThemeEvents.cartUpdated, (event) => {
  if (event.detail?.data?.source !== 'cart-validator') {
    enforceCartRules();
  }
});

// Également valider au chargement initial de la page
document.addEventListener('DOMContentLoaded', () => {
  enforceCartRules();
});
